import { render, staticRenderFns } from "./TextEditorPDPA.vue?vue&type=template&id=738f1d55"
import script from "./TextEditorPDPA.vue?vue&type=script&lang=js"
export * from "./TextEditorPDPA.vue?vue&type=script&lang=js"
import style0 from "./TextEditorPDPA.vue?vue&type=style&index=0&id=738f1d55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports